import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadSms: false,
  sms: [],
};

const smsSlice = createSlice({
  name: "sms",
  initialState,
  reducers: {
    getAllNewSms(state, action) {
      state.loadSms = false;
      state.sms = action.payload;
      state.loadSms = true;
    },
    loadSms(state, action) {
      state.loadStatus = action.payload;
    },
  },
});

export default smsSlice.reducer;
export const { getAllNewSms, loadSms } = smsSlice.actions;
